import { useQuery } from '@tanstack/react-query'

import type {
  AnswerRateRequest,
  AnswerRateResponse,
  ApiError,
} from '@mangovoice/types'

import { useReportingApi } from '../api/context'
import { REPORTING_QUERY_KEYS } from '../api/endpoints'

interface UseGetAnswerRateParams {
  request?: AnswerRateRequest
  enabled?: boolean
}

export const useGetAnswerRate = ({
  request,
  enabled = true,
}: UseGetAnswerRateParams) => {
  const api = useReportingApi()

  return useQuery<AnswerRateResponse, ApiError>({
    queryKey: [REPORTING_QUERY_KEYS.answerRate, request],
    queryFn: async () => {
      if (!request) throw new Error('Request is required')

      const { ok, data } = await api.getAnswerRate(request)

      if (!ok) {
        return Promise.reject(data as ApiError)
      }

      if (!data) {
        return Promise.reject(
          new Error('No data returned from answer rate API'),
        )
      }

      return data
    },
    enabled: enabled && !!request,
    retry: false,
  })
}
